export default __webpack_public_path__ + "static/media/Ovianihin.ee699cfc.png";